import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { ACTIVATION_STEPS, ActivationStepDef } from '../lib/activationSteps';

export interface ActivationStep extends ActivationStepDef { done: boolean; }

export interface ActivationState {
  steps: ActivationStep[];
  nextStep: ActivationStep | null;
  doneCount: number;
  allDone: boolean;
  loading: boolean;
  error: boolean;
}

export function useActivationSteps(): ActivationState {
  const [status, setStatus] = useState<Record<string, boolean> | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = (await supabase.auth.getSession()).data.session?.access_token;
        if (!token) { if (!cancelled) { setError(true); setLoading(false); } return; }
        const res = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/activation-status`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error('status ' + res.status);
        const data = await res.json();
        if (!cancelled) { setStatus(data); setLoading(false); }
      } catch {
        if (!cancelled) { setError(true); setLoading(false); }
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const steps: ActivationStep[] = ACTIVATION_STEPS.map((s) => ({ ...s, done: !!status?.[s.key] }));
  const doneCount = steps.filter((s) => s.done).length;
  const nextStep = steps.find((s) => !s.done) || null;
  return { steps, nextStep, doneCount, allDone: !!status && doneCount === steps.length, loading, error };
}
